import { useCurrentUserInfo } from '@air/utils-auth';

export const useAccountAuthProvider = () => {
  const { data: user } = useCurrentUserInfo();

  return {
    accountAuthProvider: user?.attributes?.identities?.[0]?.providerType,
  };
};
